var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7052 13.62C49.142 13.62 54.38 18.858 54.38 25.2948V33.924C54.38 40.3608 49.142 45.5988 42.7052 45.5988H20.2412C17.1632 45.5988 15.2624 44.6268 13.9448 43.7736C13.664 43.59 13.3508 43.5036 13.0376 43.5036C12.6272 43.5036 12.2168 43.6656 11.9144 44.0004C11.5256 44.3352 9.4628 45.21 7.1732 45.21C6.5144 45.21 5.9096 45.1452 5.3372 45.0048C8.1344 42.8556 8.5124 40.5012 8.5988 38.3736C8.6096 37.6068 8.5988 36.9696 8.588 36.2244C8.5772 35.598 8.5664 34.8852 8.5664 33.9348V25.3056C8.5664 18.8688 13.8044 13.6308 20.2412 13.6308H42.7052V13.62ZM42.7052 12H20.2412C12.8864 12 6.9356 17.9508 6.9356 25.2948V33.924C6.9356 35.9868 6.9896 36.9264 6.968 38.3412C6.8816 40.4256 6.6764 42.8556 2 45.1344C3.5444 46.398 5.402 46.83 7.1624 46.83C9.9704 46.83 12.5192 45.7284 13.0592 45.1452C14.9276 46.3548 17.0984 47.2296 20.2304 47.2296H42.6944C50.0384 47.2296 55.9892 41.2788 55.9892 33.9348V25.3056C56 17.9508 50.0492 12 42.7052 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7884 25.5756C29.6156 25.8996 29.4644 26.2344 29.3456 26.5908C28.7516 28.2324 28.6652 30.036 29.108 31.7316C29.3672 32.7468 29.81 33.6864 30.404 34.5072C30.242 34.8528 29.8964 35.1012 29.4752 35.1012H19.5284C16.8392 35.1012 14.6684 32.9304 14.6684 30.2412C14.6684 27.552 16.8392 25.3812 19.5284 25.3812H29.162C29.3888 25.3704 29.6048 25.446 29.7884 25.5756Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.94 23.4048C32.888 24.6468 31.5272 26.8932 31.5272 29.4636C31.5272 33.3732 34.7024 36.5484 38.612 36.5484C42.5216 36.5484 45.6968 33.3732 45.6968 29.4636C45.6968 26.8068 44.2388 24.4956 42.068 23.2752",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5364 21.9144V27.5088",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 35.2296,
    fill: "white",
    transform: "translate(2 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEc);
export default __webpack_public_path__ + "static/media/iconEC.402a4fc7.svg";
export { ForwardRef as ReactComponent };